import React from 'react';
import { useTranslation } from 'react-i18next';
import './CopyDivToClipBoardButton.scss';

function CopyDivToClipBoardButton({
  onClick,
  buttonSize,
  buttonLayout = 'textNextToBtn', // 'textBelowBtn' | 'textNextToBtn'
  buttonStyle = 'secondary', // kept for API symmetry; topnav uses native old button
  className = '',
  isIconWhite,
  isShowText
}) {
  const { t } = useTranslation();

  const layoutClass = buttonLayout === 'textBelowBtn' ? 'copy--below' : 'copy--next';
  const rootClass = ['copytoClipboard', layoutClass, className].filter(Boolean).join(' ');
  const buttonSizeClass = buttonSize === 'small' ? 'copy-btn-small' : 'copy-btn-medium';
  const buttonStyleClass = buttonStyle === 'secondary' ? 'copy-btn-secondary' : 'copy-btn-primary';
  const isIconWhiteClass = isIconWhite ? 'copytoclipboard.png' : 'icon_30_copytoclipboard.png';
  return (
    <button className={rootClass} onClick={onClick} type="button">
      <span className={"copytoClipboard-button " + buttonSizeClass + ' ' + buttonStyleClass}>
        <img src={`/assets/icons/${isIconWhiteClass}`} alt="copy" />
      </span>
      {isShowText && t('general.copyToClipboard')}
    </button>
  );
}

export default CopyDivToClipBoardButton;


